export default __webpack_public_path__ + "static/media/durvis-11-min.1119dc19.jpg";